import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.reviewops.financial.trend.chart');
import { Input, OnChanges } from '@angular/core';

interface CoreMetric {
    key: string;
    label: string;
    unit: string;
}

interface YearlyMetric {
    year: number;
    source: Record<string, number | null>;
    metrics: Record<string, number | null>;
}

interface FinancialMetricsData {
    years?: YearlyMetric[];
}

interface TrendOption extends CoreMetric {
    source?: boolean;
}

interface TrendPoint {
    x: number;
    y: number;
    year: number;
    value: number;
}

@Component({
    selector: 'wiz-component-reviewops-financial-trend-chart',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.reviewops.financial.trend.chart/view.scss */
.ro-trend-grid {
  background-image: linear-gradient(to right, rgba(148, 163, 184, 0.12) 1px, transparent 1px), linear-gradient(to bottom, rgba(148, 163, 184, 0.12) 1px, transparent 1px);
  background-size: 40px 32px;
}`],
})
export class ComponentReviewopsFinancialTrendChartComponent implements OnChanges {
    @Input() coreMetrics: CoreMetric[] = [];
    @Input() financialMetrics: FinancialMetricsData = {};
    public metricKey: string = 'revenue';

    public ngOnChanges(): void {
        const keys = this.options().map((item) => item.key);
        if (!keys.includes(this.metricKey)) this.metricKey = keys[0] || 'revenue';
    }

    public options(): TrendOption[] {
        return [{ key: 'revenue', label: 'Revenue', unit: '억원', source: true }, ...this.coreMetrics];
    }

    public selected(): TrendOption | undefined {
        return this.options().find((item) => item.key === this.metricKey);
    }

    public select(key: string): void {
        this.metricKey = key;
    }

    public points(): TrendPoint[] {
        const rows = this.financialMetrics.years || [];
        const selected = this.selected();
        const available = rows.map((row, index) => ({
            index,
            year: row.year,
            value: selected?.source ? row.source[this.metricKey] : row.metrics[this.metricKey],
        })).filter((item) => item.value !== null && item.value !== undefined);
        if (!available.length) return [];
        const values = available.map((item) => Number(item.value));
        let min = Math.min(...values);
        let max = Math.max(...values);
        if (max === min) { max += 1; min -= 1; }
        return available.map((item) => ({
            x: 38 + item.index * (244 / Math.max(1, rows.length - 1)),
            y: 126 - ((Number(item.value) - min) / (max - min)) * 82,
            year: item.year,
            value: Number(item.value),
        }));
    }

    public polyline(): string {
        return this.points().map((point) => `${point.x},${point.y}`).join(' ');
    }

    public display(value: number): string {
        return value.toLocaleString('ko-KR', { maximumFractionDigits: 1 }) + (this.selected()?.unit || '');
    }
}

export default ComponentReviewopsFinancialTrendChartComponent;